// #region Imports
import { useState } from "react";
import { pageMinDelay } from "../utils/pageMinDelay";
import { AnimatePresence } from "framer-motion";
import { ReactLenis } from "@studio-freight/react-lenis";

import Loading from "../components/Loader/index";
import Footer from "../components/Footer";

const Home = pageMinDelay(() => import("./Home"), 2000);
// #endregion

function App() {
  const [progress, setProgress] = useState(0);

  return (
        <ReactLenis
            className="home"
            root={true}
            options={{
                smoothWheel: true,
                duration: 2,
                lerp: 0.02,
                easing: (t) =>
                    Math.min(
                        1,
                        1.001 - Math.pow(2, -10 * t)
                    ),
            }}
        >
            <AnimatePresence>
                {progress < 98 && (
                    <Loading progress={progress} setProgress={setProgress} />
                )}
                <Home />
                <Footer />
                <aside key="psuedo-loader" className="loader"></aside>
            </AnimatePresence>
        </ReactLenis>
  );
}

export default App;
